/**
 * Definition for View Time
 * @module views/ViewTime
 */
import * as THREE from 'three';
import { createTextLabel, sortByYear } from '../util';
import { itemFaceCamera } from './Behaviours';
import config from '../config';

export default {

    /**
     * URI used in URL
     * @type String
     */
    path: '/time/',
    /**
     * is this views cameraIndex limited 0-1?
     * @type boolean
     */
    isFinite: true,
    /**
     * the desiredCameraIndex on view load
     * @type float
     */
    startCameraNormal: 0,
    labels: [],
    currentYear: 1904,

    /**
     * @type function
     */
    willMount() {
    },
    /**
     * @param items {Array} Array of Items
     */
    willUnmount(items) {
        
        items.forEach((item, i) => {
            for (var k = item.element.children.length-1; k>=0; k--) {
                item.element.remove(item.element.children[k]);
            }
        });

        this.labels = [];
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param items {Array} Array of Items
     */
    update(cam, items) {

        let closestDistance = 9999,
            closestItem = null;

        items.forEach((item, i) => {
            itemFaceCamera.call(item);

            //find closest item and store the year
            const measureFrom = cam.cameraWrap.position.clone();
            measureFrom.z -= 8;
            const dist = measureFrom.distanceTo(item.element.position);
            if(dist < closestDistance) {
                closestDistance = dist;
                closestItem = item;
            }
        });

        if(closestItem) this.currentYear = closestItem.props.year || '';
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param isInitial {boolean} true if items should be placed instantly
     */
    arrangeItems(items, isInitial) {

        items = items.sort(sortByYear);

        let currentYear = 0;
        let totalRad = 0;
        const length = items.length;

        items.forEach((item, i) => {

            const radius = config.views.time.radius;
            const itemRadius = item.element.geometry.boundingSphere.radius;
            const hypothenuse = Math.hypot(radius, itemRadius);
            const rad = Math.sin(itemRadius/hypothenuse);

            totalRad += rad*config.views.time.spread;

            const x = Math.sin(totalRad) * radius;
            const y = Math.cos(totalRad) * radius * 0.9;
            const z = ((i/length)-0.5)*-config.views.time.length;

            //add year label to first item
            if(item.props.year !== currentYear) {
                currentYear = item.props.year;

                const labelText = currentYear ? currentYear : 'unbekannt';
                const label = createTextLabel(labelText, 4, 2);
                this.labels.push(label);

                const lx = Math.sin(totalRad) * itemRadius;
                const ly = Math.cos(totalRad) * itemRadius;
                const lz = 0.25;

                label.position.set(lx, ly, lz);
                item.element.add(label);
            }

            item.desiredPosition = new THREE.Vector3(x,y,z);

            if(isInitial) item.currentPosition = item.desiredPosition;

            totalRad += rad*config.views.time.spread;
        });
    },

    /**
     * @param i {float} currentCameraIndex
     * @param cameraWrap {Object} [THREE.js CameraWrap]
     * @param camera {Object} [THREE.js Camera]
     */
    lerpCamera(i) {

        const position = new THREE.Vector3();
        position.z = ((i-0.5)*-(config.views.time.length)) + 8;
        return position;
    }
}